<template>
  <header class="page_header py-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-3">
          <router-link :to="{ name: 'home' }"
            ><img
              class="img-fluid"
              src="./../assets/img/logo.svg"
              alt="4k-soft"
          /></router-link>
        </div>
        <div class="col-9">
          <div class="row g-0 y-4 py-lg-0">
            <div class="col-12 d-flex">
              <div
                class="flex-column flex-lg-row row g-0 w-100 align-items-center justify-content-between justify-content-lg-center"
              >
                <div class="col-12 col-lg-8 d-none d-lg-block">
                  <nav class="page_header_nav">
                    <ul
                      class="d-lg-flex align-items-center justify-content-center main_menu list-unstyled m-0"
                    >
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none px-4 py-3 py-lg-2 d-block"
                          href="#main"
                          >Main
                        </a>
                      </li>
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none py-3 px-4 py-lg-2 d-block"
                          href="#how-it-works"
                          >How it works?
                        </a>
                      </li>
                      <li class="main_menu__item text-center text-lg-left">
                        <a
                          class="text-decoration-none px-4 py-3 py-lg-2 d-block"
                          href="#ai-solution"
                        >
                          AI Solutions
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="col-12 col-lg-4" id="auth-cabinete">
                  <div class="d-flex justify-content-end">
                    <button
                      v-if="!isLogged"
                      class="btn btn-primary"
                      id="header-contact-btn"
                      @click="signUpAndOpenModal"
                    >
                      Log In
                    </button>
                    <button
                      v-else
                      class="btn btn-primary"
                      id="header-back-to-account"
                      @click="goToRoom"
                    >
                      Back To Account
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import store from "../vuex/store";
import Modal from "./Modal.vue";

export default {
  name: "HeaderHomePage",
  data() {
    return {
      showModal: false,
    };
  },

  components: { Modal },

  computed: {
    isLogged() {
      return (
        localStorage.getItem("token") && localStorage.getItem("refreshToken")
      );
    },
  },

  methods: {
    signUpAndOpenModal() {
      this.$emit("openModal");
    },
    goToRoom() {
      store.dispatch("setLoggedIn", true);
      this.$router.push("/user");
    },
  },
};
</script>

<style scoped lang="scss">
#header-back-to-account {
  font-size: 1rem;
  white-space: nowrap;
}
</style>
